<!-- components/GlobalSnackbar.vue -->
<template>
  <v-snackbar
    v-model="snackbarState.show"
    :color="snackbarState.color"
    dark
    :timeout="snackbarState.timeout"
    :top="snackbarState.location === 'top'"
    :bottom="snackbarState.location === 'bottom'"
    :left="snackbarState.location === 'left'"
    :right="snackbarState.location === 'right'"
    :multi-line="isMultiLine"
    :vertical="isVertical"
    rounded="pill"
    elevation="6"
    content-class="global-snackbar-content"
  >
    <div class="d-flex align-center">
      <v-icon small color="white" class="mr-2">
        {{ snackbarIcon }}
      </v-icon>
      <div>
        <span class="snackbar-message">{{ snackbarState.message }}</span>

        <!-- Referência de correlação (salvia-798). Aparece só quando o backend
             manda uma. O usuário informa esse código ao time, que acha a
             exceção original no log sem precisar reproduzir o problema. -->
        <div v-if="referenciaCurta" class="snackbar-ref d-flex align-center">
          <span>ref.: {{ referenciaCurta }}</span>
          <v-btn
            icon
            x-small
            class="ml-1"
            :title="copiado ? 'Copiado' : 'Copiar referência'"
            @click="copiarReferencia"
          >
            <v-icon x-small color="white">
              {{ copiado ? "mdi-check" : "mdi-content-copy" }}
            </v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" class="snackbar-close-btn" @click="hideSnackbar">
        Fechar
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { useSnackbar } from "@/composables/useSnackbar";

export default {
  name: "GlobalSnackbar",

  setup() {
    const { snackbarState, hideSnackbar } = useSnackbar();

    return {
      snackbarState,
      hideSnackbar,
    };
  },

  data: () => ({
    copiado: false,
  }),

  watch: {
    // Cada novo aviso zera o "Copiado", senão o ícone de confirmação fica
    // preso do erro anterior.
    "snackbarState.show"() {
      this.copiado = false;
    },
  },

  methods: {
    async copiarReferencia() {
      const ref = this.snackbarState.reference;
      if (!ref) return;

      try {
        await navigator.clipboard.writeText(ref);
      } catch (e) {
        // clipboard exige contexto seguro (https) e permissão; sem ele, o
        // usuário ainda consegue ler e digitar o código, que é curto.
        return;
      }

      this.copiado = true;
    },
  },

  computed: {
    /**
     * O identificador completo é um UUID de 36 caracteres — comprido demais
     * para um toast. Mostramos os 8 primeiros, que já são suficientes para
     * localizar a linha no log, e o botão copia o valor inteiro.
     */
    referenciaCurta() {
      const ref = this.snackbarState.reference;
      return ref ? String(ref).slice(0, 8).toUpperCase() : null;
    },

    // Verifica se a mensagem é multi-linha
    isMultiLine() {
      return this.snackbarState.message.length > 50;
    },

    // Verifica se deve usar layout vertical
    isVertical() {
      return this.snackbarState.message.length > 80;
    },

    // Ícone segundo o color (mantém a lógica do composable)
    snackbarIcon() {
      const map = {
        success: "mdi-check-circle",
        error: "mdi-alert-circle",
        warning: "mdi-alert",
        info: "mdi-information",
      };
      return map[this.snackbarState.color] || "mdi-information";
    },
  },
};
</script>

<style scoped>
.snackbar-message {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.2px;
  color: #ffffff; /* fundo é sempre colorido (success/error/…) → texto branco */
}

.snackbar-ref {
  font-size: 11px;
  font-family: ui-monospace, Menlo, Consolas, monospace;
  letter-spacing: 0.4px;
  color: rgba(255, 255, 255, 0.85);
  margin-top: 2px;
}

.snackbar-close-btn {
  font-size: 12px !important;
  font-weight: 700 !important;
  letter-spacing: 0.4px !important;
  text-transform: uppercase !important;
}
</style>
